import { createApi } from '@reduxjs/toolkit/query/react'
import { HYDRATE } from 'next-redux-wrapper'

import { ArticleDetail, ArticleListItem } from '~/shared/components/Articles/ArticlesList/ArticlesList.types'
import { MediabankAsset, NewsItem } from '~/types/media'
import { SanityQuery } from '~/redux/utils/sanity-query'

import {
  getMediabankAssetDetailQuery,
  getMediabankAssetsListQuery,
  getNewsItemsListQuery,
  getPressReleaseDetailQuery,
  getPressReleasesListQuery,
} from '~/shared/queries/media'

export const mediaApi = createApi({
  reducerPath: 'mediaApi',
  baseQuery: SanityQuery,
  tagTypes: [],
  extractRehydrationInfo(action, { reducerPath }) {
    if (action.type === HYDRATE) {
      return action.payload[reducerPath]
    }
  },
  endpoints: (builder) => ({
    getMediabankAssetsList: builder.query<MediabankAsset[], { language: string }>({
      query: (queryParams) => ({
        queryString: getMediabankAssetsListQuery,
        queryParams,
      }),
    }),

    getMediabankAssetDetail: builder.query<MediabankAsset, { language: string; slug: string }>({
      query: (queryParams) => ({
        queryString: getMediabankAssetDetailQuery,
        queryParams,
      }),
    }),

    getNewsItemsList: builder.query<NewsItem[], { language: string }>({
      query: (queryParams) => ({
        queryString: getNewsItemsListQuery,
        queryParams,
      }),
    }),

    getPressReleasesList: builder.query<ArticleListItem[], { language: string }>({
      query: (queryParams) => ({
        queryString: getPressReleasesListQuery,
        queryParams,
      }),
    }),

    getPressReleaseDetail: builder.query<ArticleDetail, { language: string; slug: string }>({
      query: (queryParams) => ({
        queryString: getPressReleaseDetailQuery,
        queryParams,
      }),
    }),
  }),
})

export const {
  useGetMediabankAssetDetailQuery,
  useGetMediabankAssetsListQuery,
  useGetNewsItemsListQuery,
  useGetPressReleaseDetailQuery,
  useGetPressReleasesListQuery,
  util: { getRunningQueriesThunk },
} = mediaApi

export const {
  getMediabankAssetDetail,
  getMediabankAssetsList,
  getNewsItemsList,
  getPressReleaseDetail,
  getPressReleasesList,
} = mediaApi.endpoints
